import { Link } from 'react-router-dom';
import { getCategoryBySlug, getLatestSites } from '@/utils/nav';

export default function LatestList() {
  const latestSites = getLatestSites(6);

  return (
    <section className="mt-10">
      <div className="mb-5 flex flex-wrap items-end justify-between gap-3">
        <div>
          <span className="mb-1 inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-secondary-600">
            <span className="h-1 w-1 rounded-full bg-secondary-500"></span>
            持续更新
          </span>
          <h2 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">
            最新收录
          </h2>
          <p className="mt-1 text-sm text-foreground-500">
            最近加入蓝导航的新网站，抢先体验新入口。
          </p>
        </div>
      </div>

      <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
        {latestSites.map((site, index) => {
          const category = getCategoryBySlug(site.category);
          return (
            <div
              key={site.id}
              className={`flex flex-col gap-3 px-4 py-4 transition-colors hover:bg-background-100 sm:flex-row sm:items-center md:px-5 ${
                index !== latestSites.length - 1
                  ? 'border-b border-background-200'
                  : ''
              }`}
            >
              <Link
                to={`/detail/${site.id}`}
                className="flex min-w-0 flex-1 items-center gap-3"
              >
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary-100 font-heading text-sm font-bold text-primary-700">
                  {site.initial}
                </span>
                <span className="min-w-0">
                  <span className="block truncate font-heading text-sm font-semibold text-foreground-950">
                    {site.name}
                  </span>
                  <span className="mt-0.5 block truncate text-xs text-foreground-500">
                    {category?.label} · {site.description}
                  </span>
                </span>
              </Link>

              <div className="flex items-center gap-3 sm:shrink-0">
                <span className="flex items-center gap-1 whitespace-nowrap text-xs text-foreground-500">
                  <i className="ri-calendar-line"></i>
                  {site.addedAt}
                </span>
                <a
                  href={site.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3 py-1.5 text-xs font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
                >
                  访问
                  <i className="ri-arrow-right-up-line"></i>
                </a>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}